import React from 'react';
import Utils from '../../lib/Utils';
import API from '../../lib/API';

class QrRequestForm extends React.Component {

  state = {
    categories:['slideshow'],
  
    school: this.props.data.school || this.props.data.albums[0].code,

    amount: 0,
    release_date_type:'nouhinbi',
    release_date:'',
    download:'on',
    lead_page_type:'tobira',
    lead_page_other:'',
    song:'off',
    capacity:'safe',

    cate_1_title: '', cate_1_count: '',
    cate_2_title: '', cate_2_count: '',
    cate_3_title: '', cate_3_count: '',
    cate_4_title: '', cate_4_count: '',
    cate_5_title: '', cate_5_count: '',
    cate_6_title: '', cate_6_count: '',
    cate_7_title: '', cate_7_count: '',
    cate_8_title: '', cate_8_count: '',
    cate_9_title: '', cate_9_count: '',
    cate_10_title: '', cate_10_count: '',
    cate_11_title: '', cate_11_count: '',

    caution: '',

    amount_validate_message:null,
    release_date_validate_message:null,
    lead_page_validate_message:null,
    caution_validate_message:null,
    cate_1_validation_message:null,
    cate_2_validation_message:null,
    cate_3_validation_message:null,
    cate_4_validation_message:null,
    cate_5_validation_message:null,
    cate_6_validation_message:null,
    cate_7_validation_message:null,
    cate_8_validation_message:null,
    cate_9_validation_message:null,
    cate_10_validation_message:null,
    cate_11_validation_message:null,
  }


  componentDidMount = () => {
    this.loadAlbumData(this.state.school);
  }

  getData = () => {

    let formData = {
      doc_date: (new Date()).toLocaleDateString('sv-SE'),
      amount: this.state.amount,
      release_date_type: this.state.release_date_type,
      release_date: this.state.release_date_type === 'other' ? this.state.release_date : '',
      download: this.state.download,
      lead_page_type: this.state.lead_page_type,
      lead_page_other: this.state.lead_page_type === 'other' ? this.state.lead_page_other : '',
      song: this.state.song,
      capacity: this.state.capacity,

      caution: this.state.caution
    };
    let total_count = 0;
    for (let i = 1; i <= this.state.categories.length; i++) {
      if (this.state.categories.length >= i) {
        formData['cate_'+i+'_title'] = this.state['cate_'+i+'_title'];
        formData['cate_'+i+'_count'] = this.state['cate_'+i+'_count'];
        total_count += parseInt(this.state['cate_'+i+'_count'], 10);
      }
      else {
        formData['cate_'+i+'_title'] = '';
        formData['cate_'+i+'_count'] = '';
      }
    }
    formData.total_count = total_count;

    return {
      schoolCode: this.state.school,
      hinmei: this.props.data.albums.find(a=>a.code===this.state.school).hinmei,
      filename: "QR動画申請_" + Utils.getHyphenationDate(),
      form: formData
    };
  }

  validation = () => {
    let newState = {};

    newState.amount_validate_message = (()=>{
      if (this.state.amount === '') return '予定冊数を入力してください。';
      if (parseInt(this.state.amount,10) <= 0) return '予定冊数を入力してください。';
      return null;
    })();
    newState.release_date_validate_message = (()=>{
      if (this.state.release_date_type === 'other') {
        if (this.state.release_date === '') return '公開日を指定してください。';
        if (!this.state.release_date.match(/^\d{4}-\d{2}-\d{2}$/)) return 'YYYY-MM-DDの形式で入力してください。';
        if (this.state.release_date < (new Date()).toLocaleDateString('sv-SE')) return '公開日が過去の日付です。';
      }
      return null;
    })();
    newState.lead_page_validate_message = (()=>{
      if (this.state.lead_page_type === 'other') {
        if (this.state.lead_page_other === '') return '印刷するページを指定してください。';
      }
      return null;
    })();
    newState.caution_validate_message = (()=>{
      if (this.state.song === 'on' && this.state.caution === '') return '校歌を使用するスライドショーを指定してください。'
      return null;
    })();

    for (let i = 1; i <= 11; i++) {
      newState['cate_'+i+'_validate_message'] = (()=>{
        if (this.state.categories.length >= i) {
          if (this.state['cate_'+i+'_title'] === '') return 'カテゴリー名を入力してください。';
          if (this.state['cate_'+i+'_count'] === '') return '写真点数、動画の長さを入力してください。';
        }
        return null;
      })();
    }

    this.setState(newState);
    this.props.changeValidate(Object.values(newState).every(v=>v===null));
  }

  handleChangeValue = e => {
    let newState = {};
    newState[e.target.name] = e.target.value.trim();
    this.setState(newState, () =>{
      this.validation();
    });

    if (e.target.name === 'school') {
      this.loadAlbumData(e.target.value);
    }
  }

  loadAlbumData = (schoolCode) => {
    this.props.doLoading('アルバムデータの読み込み中');
    API.getAlbum(schoolCode).then(data=>{
      this.setState({
        amount: data.info.kazu,
      });
      this.props.doLoading(null);
    });
  }

  handleMouseDownDatePicker = e => {
    let name = e.target.name;
    this.props.openDatePicker(e.target, value => {
      let newState = {};
      newState[name] = value;
      this.setState(newState, () =>{
        this.validation();
      });
    })
  }

  handleClickAddCategory = e => {
    e.preventDefault();
    if (this.state.categories.length >= 11) return;
    let categories = this.state.categories;
    categories.push(categories[categories.length-1]);
    this.setState({
      categories: categories
    }, () =>{
      this.validation();
    });
  }
  handleClickRemoveCategory = e => {
    e.preventDefault();
    if (this.state.categories.length <= 1) return;
    let categories = this.state.categories;
    categories.pop();
    this.setState({
      categories: categories
    }, () =>{
      this.validation();
    });
  }
  handleChangeMovieType = e => {
    console.log(e.target.dataset.index, e.target.value);
    let categories = this.state.categories;
    categories[parseInt(e.target.dataset.index, 10)-1] = e.target.value;
    this.setState({
      categories: categories
    })
  }

  renderForm = () => {
    return (<form ref={ref=>{this.form=ref}}>

      <div className="formBlock titleBlock">
        <div className="titleBlock-wrap">
          <h2>QR動画サービスのお申し込み</h2>
          <div>QR動画のお申し込みフォームです。</div>
        </div>
      </div>

      <div className="formBlock">
        <div className="formBlock-title">対象の学校</div>
        <div className="formBlock-input">
          <select name="school" value={this.state.school} onChange={this.handleChangeValue}>{
            this.props.data.albums.map(a => {
              return <option key={a.code} value={a.code}>{a.hinmei}</option>
            })
          }</select>
        </div>
      </div>

      <div className="formBlock">
        <div className="formBlock-title">アルバム製作予定冊数</div>
        <div className="formBlock-input">
          <input name="amount" type="number" min="1" value={this.state.amount} onChange={this.handleChangeValue} required pattern="^\d+$"/>
        </div>
        {!this.state.amount_validate_message?null
        :<div className="formBlock-error">{this.state.amount_validate_message}</div>}
      </div>

      <div className="formBlock">
        <div className="formBlock-title">動画の公開日</div>
        <div className="formBlock-input">
          <div className="formBlock-checkbox">
            <label>
              <input name="release_date_type" type="radio" value="nouhinbi" checked={this.state.release_date_type === 'nouhinbi'} onChange={this.handleChangeValue}/>
              納品日
            </label>
          </div>
          <div className="formBlock-checkbox">
            <label>
              <input name="release_date_type" type="radio" value="other" checked={this.state.release_date_type === 'other'} onChange={this.handleChangeValue}/>
              その他
              {this.state.release_date_type !== 'other'?null
               : <input name="release_date" onMouseDown={this.handleMouseDownDatePicker} 
                value={this.state.release_date} onChange={this.handleChangeValue} required pattern="^\d{4}-\d{2}-\d{2}$"/>
              }
              {!this.state.release_date_validate_message?null
              :<div className="formBlock-error">{this.state.release_date_validate_message}</div>}
            </label>
          </div>
        </div>
      </div>

      <div className="formBlock">
        <div className="formBlock-title">動画のダウンロード</div>
        <div className="formBlock-input">
          <div className="formBlock-checkbox">
            <label>
              <input name="download" type="radio" value="on" checked={this.state.download === 'on'} onChange={this.handleChangeValue}/>
              許可
            </label>
          </div>
          <div className="formBlock-checkbox">
            <label>
              <input name="download" type="radio" value="off" checked={this.state.download === 'off'} onChange={this.handleChangeValue}/>
              禁止
            </label>
          </div>
        </div>
      </div>

      <div className="formBlock">
        <div className="formBlock-title">QRを印刷するページ</div>
        <div className="formBlock-input">
          <div className="formBlock-checkbox">
            <label>
              <input name="lead_page_type" type="radio" value="tobira" checked={this.state.lead_page_type === 'tobira'} onChange={this.handleChangeValue}/>
              扉
            </label>
          </div>
          <div className="formBlock-checkbox">
            <label>
              <input name="lead_page_type" type="radio" value="urami" checked={this.state.lead_page_type === 'urami'} onChange={this.handleChangeValue}/>
              裏見返し
            </label>
          </div>
          <div className="formBlock-checkbox">
            <label>
              <input name="lead_page_type" type="radio" value="other" checked={this.state.lead_page_type === 'other'} onChange={this.handleChangeValue}/>
              その他
              {this.state.lead_page_type !== 'other'?null
              : <input name="lead_page_other" value={this.state.lead_page_other} onChange={this.handleChangeValue} required/>
              }
              {!this.state.lead_page_validate_message?null
              :<div className="formBlock-error">{this.state.lead_page_validate_message}</div>}
            </label>
          </div>
        </div>
      </div>

      <div className="formBlock">
        <div className="formBlock-title">校歌</div>
        <div className="formBlock-message">
          <p>スライドショーの音楽として校歌を使用する場合は「あり」にして、割り当てるスライドショーを「その他の注意事項」で指定してください。</p>
        </div>
        <div className="formBlock-input">
          <div className="formBlock-checkbox">
            <label>
              <input name="song" type="radio" value="on" checked={this.state.song === 'on'} onChange={this.handleChangeValue}/>
              あり
            </label>
          </div>
          <div className="formBlock-checkbox">
            <label>
              <input name="song" type="radio" value="off" checked={this.state.song === 'off'} onChange={this.handleChangeValue}/>
              なし
            </label>
          </div>
        </div>
      </div>

      <div className="formBlock">
        <div className="formBlock-title">その他注意事項</div>
        <div className="formBlock-input">
          <textarea name="caution" value={this.state.caution} onChange={this.handleChangeValue}></textarea>
        </div>
        {!this.state.caution_validate_message?null
        :<div className="formBlock-error">{this.state.caution_validate_message}</div>}
      </div>

      {(()=>{
        let categories = [];
        for (let i = 1; i <= this.state.categories.length; i++) {
          categories.push(<div className="formBlock" key={i}>
            <div className="formBlock-title">動画 {i}</div>
            <div className="formBlock-input">
              <div className="formBlock-checkbox">
                <label>
                  <input name={"cate_"+i+"_type"} data-index={i} type="radio" value="slideshow" checked={this.state.categories[i-1] === 'slideshow'} onChange={this.handleChangeMovieType}/>
                  スライドショー
                </label>
                <label>
                  <input name={"cate_"+i+"_type"} data-index={i} type="radio" value="movie" checked={this.state.categories[i-1] === 'movie'} onChange={this.handleChangeMovieType}/>
                  動画
                </label>
              </div>
              {this.state.categories[i-1] === 'slideshow'
                ? (<div>
                  <label>カテゴリー名（アップロードフォルダ名）</label>
                  <input name={"cate_"+i+"_title"} value={this.state["cate_"+i+"_title"]} onChange={this.handleChangeValue} required/>
                  <label>写真点数（300枚まで）</label>
                  <input name={"cate_"+i+"_count"} type="number" min="1" max="300" value={this.state["cate_"+i+"_count"]} onChange={this.handleChangeValue} required pattern="^\d+$"/>
                </div>)
                : (<div>
                  <label>カテゴリー名（動画ファイル名）</label>
                  <input name={"cate_"+i+"_title"} value={this.state["cate_"+i+"_title"]} onChange={this.handleChangeValue} required/>
                  <label>動画の長さ（分）</label>
                  <input name={"cate_"+i+"_count"} type="number" min="1" max="60" value={this.state["cate_"+i+"_count"]} onChange={this.handleChangeValue} required pattern="^\d+$"/>
                </div>)
              }

              <div className="formBlock-buttons">
                {i===1||i!==this.state.categories.length?null
                :<button onClick={this.handleClickRemoveCategory}>動画の削除</button>
                }
                {i!==this.state.categories.length?null
                :<button onClick={this.handleClickAddCategory} disabled={this.state.categories.length>=11}>動画の追加</button>
                }
              </div>

              {!this.state['cate_'+i+'_validate_message']?null
              :<div className="formBlock-error">{this.state['cate_'+i+'_validate_message']}</div>}
            </div>
        </div>)
        }
        return categories;
      })()}



    </form>)
  }

  renderConfirm = () => {
    return (
      <div>
        <div className="formBlock titleBlock">
          <div className="titleBlock-wrap">
            <h2>QR動画のお申し込み</h2>
            <div>内容をよくご確認の上、ご申請ください。</div>
          </div>
        </div>
        <div className="confirm">
          <div className="confirm-row">
            <label>学校</label>
            <span>{this.props.data.albums.find(a=>a.code===this.state.school).hinmei}</span>
          </div>
          <div className="confirm-row">
            <label>アルバム製作予定冊数</label>
            <span>{this.state.amount}</span>
          </div>
          <div className="confirm-row">
            <label>公開日</label>
            <span>{this.state.release_date_type === 'other' ? this.state.release_date : '納品日'}</span>
          </div>
          <div className="confirm-row">
            <label>動画のダウンロード</label>
            <span>{this.state.download === 'on' ? '許可' : '禁止'}</span>
          </div>
          <div className="confirm-row">
            <label>QRを印刷するページ</label>
            <span>{(()=>{
              switch (this.state.lead_page_type) {
                case 'other': return this.state.lead_page_other;
                case 'urami': return '見返し';
                default: return 'トビラ';
              }
            })()}</span>
          </div>
          <div className="confirm-row">
            <label>スライドショー用の校歌</label>
            <span>{this.state.song === 'on' ? 'あり' : 'なし'}</span>
          </div>
          <div className="confirm-row">
            <label>その他注意事項</label>
            <span>{this.state.caution}</span>
          </div>
          {(()=>{
            let categories = [];
            for (let i = 1; i <= this.state.categories.length; i++) {
              categories.push(
                <div key={i}>
                  <div className="confirm-row">
                    <label>動画 {i}</label>
                  </div>
                  <div className="confirm-row" data-indent="1">
                    <label>{this.state.categories[i-1] === 'slideshow' ? 'カテゴリー名' : '動画ファイル名'}</label>
                    <span>{this.state['cate_'+i+'_title']}</span>
                  </div>
                  <div className="confirm-row" data-indent="1">
                    <label>{this.state.categories[i-1] === 'slideshow' ? '写真点数' : '動画の長さ'}</label>
                    <span>{this.state['cate_'+i+'_count']}</span>
                  </div>
                </div>
              );
            }
            return categories;
          })()}
          
        </div>
      </div>
    )
  }

  render () {
    switch (this.props.progress) {
      case 'form': return this.renderForm();
      case 'confirm': return this.renderConfirm();
      default: return null;
    }
  }
}
export default QrRequestForm;